import { NavLink, useLocation } from "react-router-dom";

const NAV = [
  {
    section: "Clinical",
    items: [
      { to: "/ipd-admission", label: "IPD Admission", icon: "🏥" },
      { to: "/radiology",     label: "Radiology",     icon: "🩻" },
      { to: "/lab-orders",    label: "Lab Orders",    icon: "🧪" },
      { to: "/ipd-billing",   label: "IPD Billing",   icon: "💰" },
      { to: "/ipd-files",     label: "IPD Files",     icon: "📁" },
      { to: "/procedure-master", label: "Procedures",  icon: "🔪" },
    ],
  },
];

const css = `
  .layout { display: flex; min-height: 100vh; }

  .sidebar {
    width: 230px;
    min-height: 100vh;
    background: #0D0F17;
    border-right: 1px solid #1E2130;
    display: flex;
    flex-direction: column;
    position: fixed;
    top: 0; left: 0; bottom: 0;
    z-index: 40;
  }

  .sidebar-logo {
    padding: 22px 20px 18px;
    border-bottom: 1px solid #1E2130;
  }
  .sidebar-logo-name {
    font-family: 'Playfair Display', serif;
    font-size: 17px;
    font-weight: 700;
    color: #EDF0FF;
    letter-spacing: .01em;
  }
  .sidebar-logo-sub {
    font-size: 10px;
    color: #6B7A99;
    margin-top: 2px;
    text-transform: uppercase;
    letter-spacing: .08em;
  }

  .sidebar-nav { flex: 1; padding: 16px 0; overflow-y: auto; }

  .nav-section-label {
    font-size: 9px;
    font-weight: 700;
    text-transform: uppercase;
    letter-spacing: .12em;
    color: #3D4563;
    padding: 0 20px 8px;
  }

  .nav-item {
    display: flex;
    align-items: center;
    gap: 10px;
    padding: 9px 20px;
    font-size: 13px;
    font-weight: 500;
    color: #6B7A99;
    text-decoration: none;
    border-radius: 0;
    transition: all .15s;
    border-left: 3px solid transparent;
    font-family: 'IBM Plex Sans', sans-serif;
  }
  .nav-item:hover { background: #111318; color: #EDF0FF; }
  .nav-item.active {
    background: rgba(94,123,255,.1);
    color: #8B9FFF;
    border-left-color: #5E7BFF;
  }
  .nav-icon { font-size: 15px; width: 20px; text-align: center; flex-shrink: 0; }

  .sidebar-footer {
    padding: 14px 20px;
    border-top: 1px solid #1E2130;
    font-size: 11px;
    color: #3D4563;
  }

  .main-content {
    margin-left: 230px;
    flex: 1;
    min-height: 100vh;
  }
`;

export default function Layout({ children }) {
  return (
    <>
      <style>{css}</style>
      <div className="layout">
        <aside className="sidebar">
          <div className="sidebar-logo">
            <div className="sidebar-logo-name">ClinicMS</div>
            <div className="sidebar-logo-sub">Management System</div>
          </div>

          <nav className="sidebar-nav">
            {NAV.map(section => (
              <div key={section.section} style={{ marginBottom: 8 }}>
                <div className="nav-section-label">{section.section}</div>
                {section.items.map(item => (
                  <NavLink
                    key={item.to}
                    to={item.to}
                    className={({ isActive }) =>
                      "nav-item" + (isActive ? " active" : "")
                    }
                  >
                    <span className="nav-icon">{item.icon}</span>
                    {item.label}
                  </NavLink>
                ))}
              </div>
            ))}
          </nav>

          <div className="sidebar-footer">v1.0 · City Health Clinic</div>
        </aside>

        <main className="main-content">{children}</main>
      </div>
    </>
  );
}
